import { AthosFetcher } from 'libs/athos/classes/athos-fetcher'

import { generateAthosProvider } from 'libs/athos/fetchers/provider'
import { normaliseResults } from 'libs/athos/helpers/normalisers'
import { isAthosInstockOnly } from 'libs/athos/athos-utils'
import type { AthosFetchOptions } from 'libs/athos/athos.types'

export class AthosAutocomplete extends AthosFetcher {
  generateURL() {
    return super.generateURL('/autocomplete')
  }

  updateParams(options: AthosFetchOptions = {}) {
    const { query, originalQuery, resultsPerPage } = options

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')

    this.params.set('q', query)
    if (isAthosInstockOnly()) this.params.set('bgfilter.ss_available', 1)
    if (resultsPerPage) this.params.set('resultsPerPage', resultsPerPage)
    if (originalQuery) this.params.set('oq', originalQuery)

    super.updateParams()
  }
}

export const AthosAutocompleteProvider = generateAthosProvider(AthosAutocomplete, async (results) => {
  const normalisedResults = await normaliseResults(results.results)
  return {
    ...results,
    results: normalisedResults
  }
})
